import { ModulesWithAvailableActivityList } from "src/app/business/available-activities/available-activities.component";
import { PermissionList } from "../internal-settings/internal-settings.interface";
import { PAActivityUtility } from "./pa-activity.utility";
import { LocalStorageService } from "src/app/system/utility/local-storage.service";
import { BiometricService } from "src/app/system/utility/biometric.service";
import { PAActivity, PAGroup } from "./pa-menu-meta";
import { PABaseUtility } from "./pa-base.utility";

export class PAGroupUtility extends PABaseUtility {

  public static buildGrpAccount(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('account', 'LABEL_ACCOUNTS', '/dashboard', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildAccountHistory(actvityIndex++),
      PAActivityUtility.buildDownloadHistory(actvityIndex++),
      PAActivityUtility.buildDownloadStatement(actvityIndex++),
      PAActivityUtility.buildViewMaintenance(actvityIndex++),
      PAActivityUtility.buildScheduledTransactions(actvityIndex++),
      PAActivityUtility.buildApplyNewProducts(actvityIndex++),
    ]))
  }

  public static buildGrpInternalTransfers(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('internalTransfer', 'LABEL_INTERNAL_TRANSFERS', '/internal-transfer', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildInternalTransfer(actvityIndex++),
      PAActivityUtility.buildTransfersByText(actvityIndex++),
      PAActivityUtility.buildCrossCurrencyTransfer(actvityIndex++),
    ]))
  }

  public static buildGrpExternalTransfers(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('externalTransfer', 'LABEL_EXTERNAL_TRANSFERS', '/external-transfer-history', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildOrdersBatchOrder(actvityIndex++),
      PAActivityUtility.buildOrdersDraft(actvityIndex++),
      PAActivityUtility.buildOrdersDraftAutomated(actvityIndex++),
      PAActivityUtility.buildOrdersEft(actvityIndex++),
      PAActivityUtility.buildOrdersWire(actvityIndex++),
      PAActivityUtility.buildExternalTransfersHistory(actvityIndex++),
      PAActivityUtility.buildOrdersScheduledOrders(actvityIndex++),
      PAActivityUtility.buildOrdersTemplate(actvityIndex++),
      PAActivityUtility.buildVizSendMoney(actvityIndex++)
    ]))
  }
  
  public static buildGrpPayments(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('payments', 'LABEL_PAYMENTS', '/payment/general', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildTopupReports(actvityIndex++),
      PAActivityUtility.buildPaymentTopup(actvityIndex++),
      PAActivityUtility.buildPaymentGeneral(actvityIndex++),
      PAActivityUtility.buildPaymentDomestic(actvityIndex++),
      PAActivityUtility.buildPaymentExternal(actvityIndex++),
      PAActivityUtility.buildManagePayees(actvityIndex++),
      PAActivityUtility.buildPaymentHistory(actvityIndex++),
    ]))
  }

  public static buildGrpPayroll(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('payroll', 'PAYROLL', '/departments', index)
    .setIsModuleEnabled(this.es.globalVariables.isModuleEnabledGroupPay)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildPayrollDepartments(actvityIndex++),
      PAActivityUtility.buildPayrollBatchUpload(actvityIndex++),
      PAActivityUtility.buildPayrollDepartmentGroups(actvityIndex++),
    ]))
  }

  public static buildGrpOrders(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('orders', 'ORDERS', '/order-history', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildOrdersCash(actvityIndex++),
      PAActivityUtility.buildOrdersCheque(actvityIndex++),
      PAActivityUtility.buildOrdersHistory(actvityIndex++),
    ]))
  }

  public static buildGrpServices(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('services', 'LABEL_SERVICES', '/secureMessage', index)
    .setPermissions([PermissionList.SERVICE_ACESS_GROUP])
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildServicesApplications(actvityIndex++),
      PAActivityUtility.buildServicesCard(actvityIndex++),
      PAActivityUtility.buildServicesRequest(actvityIndex++),
      PAActivityUtility.buildServicesSmartForms(actvityIndex++),
      PAActivityUtility.buildServicesSecureMessage(actvityIndex++),
      PAActivityUtility.buildServicesStopPayment(actvityIndex++),
    ]))
  }

  public static buildGrpSettings(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('settings', 'LABEL_SETTINGS', '/settings/personal', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildSettingsAdmin(actvityIndex++),
      PAActivityUtility.buildSettingsPersonal(actvityIndex++),
      PAActivityUtility.buildSettingsPreferences(actvityIndex++),
      PAActivityUtility.buildSettingsAlerts(actvityIndex++),
      PAActivityUtility.buildSettingsBiometrics(actvityIndex++),
    ]))
  }

  public static buildGrpExternalLinks(index: number): PAGroup {
    let actvityIndex = 0;

    let activityList: PAActivity[] = [];
    let link1 = PAActivityUtility.buildExternalLink1(actvityIndex++);
    let link2 = PAActivityUtility.buildExternalLink2(actvityIndex++);
    if (link1) activityList.push(link1);
    if (link2) activityList.push(link2);

    return new PAGroup('externalLinks', 'LABEL_EXTERNAL_LINKS', '', index)
    .setIconPath('assets/images/icons/icon_external_links.png')
    .setActivities(PABaseUtility.filterActivities(activityList))
  }

  public static buildGrpCorp(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('corporate', 'LABEL_PAYMENTS', '/corporate/make-payment', index)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildCorpMakePayment(actvityIndex++),
      PAActivityUtility.buildCorpPaymentHistory(actvityIndex++),
      PAActivityUtility.buildCorpManageCustomers(actvityIndex++),
    ]))
  }

  public static buildMobileGrpHome(index: number): PAGroup {
    return new PAGroup('home', 'LABEL_HOME', '/dashboard', index)
    .setIsModuleEnabled(true)
    .setIconPath('assets/images/icons/icon_home.png')
  }

  public static buildMobileGrpInternalTransfers(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('internalTransfers', 'LABEL_INTERNAL_TRANSFERS', '/available-activities', index)
    .setIconPath('assets/images/icons/icon_transfers.png')
    .setParams(ModulesWithAvailableActivityList.INTERNAL_TRANSFERS)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildInternalTransfer(actvityIndex++),
      PAActivityUtility.buildTransfersByText(actvityIndex++),
      PAActivityUtility.buildCrossCurrencyTransfer(actvityIndex++),      
    ]))
  }

  public static buildMobileGrpExternalTransfers(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('externalTransfers', 'LABEL_EXTERNAL_TRANSFERS', '/available-activities', index)
    .setIconPath('assets/images/icons/icon_menu_external_transfer.png')
    .setParams(ModulesWithAvailableActivityList.EXTERNAL_TRANSFERS)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildOrdersDraft(actvityIndex++),
      PAActivityUtility.buildOrdersDraftAutomated(actvityIndex++),
      PAActivityUtility.buildOrdersEft(actvityIndex++),
      PAActivityUtility.buildOrdersWire(actvityIndex++),
      PAActivityUtility.buildExternalTransfersHistory(actvityIndex++),
      PAActivityUtility.buildOrdersScheduledOrders(actvityIndex++),
      PAActivityUtility.buildOrdersTemplate(actvityIndex++),
      PAActivityUtility.buildVizSendMoney(actvityIndex++)
    ]))
  }
  
  public static buildMobileGrpPayments(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('payments', 'LABEL_PAYMENTS', '/available-activities', index)
    .setIconPath('assets/images/icons/icon_payments.png')
    .setParams(ModulesWithAvailableActivityList.PAYMENTS)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildTopupReports(actvityIndex++),
      PAActivityUtility.buildPaymentTopup(actvityIndex++),
      PAActivityUtility.buildPaymentGeneral(actvityIndex++),
      PAActivityUtility.buildPaymentDomestic(actvityIndex++),
      PAActivityUtility.buildPaymentExternal(actvityIndex++),
      PAActivityUtility.buildManagePayees(actvityIndex++),
      PAActivityUtility.buildPaymentHistory(actvityIndex++),
    ]))
  }

  public static buildMobileGrpDeposits(index: number): PAGroup {
    return new PAGroup('deposits', 'LABEL_TEXT_DEPOSITS', '/mobile-cheque-deposit', index, true)
    .setPermissions([PermissionList.ACCESS_REMOTE_DEPOSIT_SERVICE, PermissionList.ACCESS_MOBILE_DEPOSIT_HISTORY])
    .setIconPath('assets/images/icons/icon_mobiledeposit.png')
  }

  public static buildMobileViewGrpQRCode(index: number): PAGroup {
    return new PAGroup('qrcode', 'LABEL_QRCODE', '/qr-main', index)
    .setPermissions([PermissionList.CREATE_PEER_QR_CODE, PermissionList.CREATE_ORDER_QR_CODE, PermissionList.SCAN_ORDER_QR_CODE, PermissionList.SCAN_MERCHANT_QR_CODE, PermissionList.SCAN_PEER_QR_CODE])
    .setIconPath('assets/images/icons/icon_qr128.png')
  }

  public static buildMobileAppGrpQRCode(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('qrcode', 'LABEL_QRCODE', '/available-activities', index)
    .setPermissions([PermissionList.CREATE_PEER_QR_CODE, PermissionList.CREATE_ORDER_QR_CODE, PermissionList.SCAN_ORDER_QR_CODE, PermissionList.SCAN_MERCHANT_QR_CODE, PermissionList.SCAN_PEER_QR_CODE])
    .setIconPath('assets/images/icons/icon_qr128.png')
    .setParams(ModulesWithAvailableActivityList.QR_CODE_PAYMENT)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildQRCodePaymentRequest(actvityIndex++),
      PAActivityUtility.buildQRCodePaymentScan(actvityIndex++),
    ]))
  }

  public static buildMobileGrpTopup(index: number): PAGroup {
    return new PAGroup('topup', 'LABEL_MOBILEARTH_TOPUP_PAYMENT', '/payment/topup', index)
    .setPermissions([PermissionList.ACCESS_MOBILEARTH_TOPUP])
    .setIconPath('assets/images/icons/icon_services.png')
  }

  public static buildMobileGrpQueue(index: number): PAGroup {
    return new PAGroup('queue', 'LABEL_QUEUE', '/mobile-queue', index)
    .setIsModuleEnabled(this.es.globalVariables.isModuleEnabledMobibranchQueue)
    .setIconPath('assets/images/icons/icon_queue.png')
  }

  public static buildMobileGrpOrders(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('orders', 'ORDERS', '/available-activities', index)
    .setIconPath('assets/images/icons/icon_orders128.png')
    .setParams(ModulesWithAvailableActivityList.ORDERS)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildOrdersCheque(actvityIndex++),
      PAActivityUtility.buildOrdersHistory(actvityIndex++),
    ]))
  }

  public static buildMobileGrpServices(index: number): PAGroup {
    let actvityIndex = 0;
    return new PAGroup('services', 'LABEL_SERVICES', '/available-activities', index)
    .setPermissions([PermissionList.SERVICE_ACESS_GROUP])
    .setIconPath('assets/images/icons/icon_services128.png')
    .setParams(ModulesWithAvailableActivityList.SERVICES)
    .setActivities(PABaseUtility.filterActivities([
      PAActivityUtility.buildServicesApplications(actvityIndex++),
      PAActivityUtility.buildServicesCard(actvityIndex++),
      PAActivityUtility.buildServicesRequest(actvityIndex++),
      PAActivityUtility.buildServicesSmartForms(actvityIndex++),
      PAActivityUtility.buildServicesScheduledTransactions(actvityIndex++),
      PAActivityUtility.buildServicesSecureMessage(actvityIndex++),
      PAActivityUtility.buildServicesStopPayment(actvityIndex++),
    ]))
  }

  public static buildMobileGrpExternalLinks(index: number): PAGroup {
    let actvityIndex = 0;

    let activityList: PAActivity[] = [];
    let link1 = PAActivityUtility.buildExternalLink1(actvityIndex++);
    let link2 = PAActivityUtility.buildExternalLink2(actvityIndex++);
    if (link1) activityList.push(link1);
    if (link2) activityList.push(link2);

    return new PAGroup('externalLinks', 'LABEL_EXTERNAL_LINKS', '/available-activities', index)
    .setIconPath('assets/images/icons/icon_external_links.png')
    .setParams(ModulesWithAvailableActivityList.EXTERNAL_LINKS)
    .setActivities(PABaseUtility.filterActivities(activityList))
  }

  public static buildSubMenuSettings(srvLocalStorage: LocalStorageService, srvBiometric: BiometricService): PAActivity[] {
    let actvityIndex = 0;
    return PABaseUtility.filterActivities([
      PAActivityUtility.buildSettingsPersonal(actvityIndex++),
      PAActivityUtility.buildSettingsPreferences(actvityIndex++),
      PAActivityUtility.buildViewMaintenance(actvityIndex++),
      PAActivityUtility.buildSettingsAlerts(actvityIndex++),
      PAActivityUtility.buildSettingsResetPush(actvityIndex++),
      PAActivityUtility.buildBiometrics(actvityIndex++, srvLocalStorage, srvBiometric),
    ])
  }
  
  public static buildSubMenuHelpCenter(): PAActivity[] {
    let actvityIndex = 0;
    return PABaseUtility.filterActivities([
      PAActivityUtility.buildHelpDesk(actvityIndex++),
      PAActivityUtility.buildContactUs(actvityIndex++),
      PAActivityUtility.buildResourceViewer(actvityIndex++),
      PAActivityUtility.buildTools(actvityIndex++),
    ])
  }
}